import { Directive, inject, Input, TemplateRef } from '@angular/core';

/**
 *
 * A structural directive allowing {@link WzbBoNavigationSidebarMenuComponent} to gather
 * icons needed by {@link NavigationItem}
 *
 * @example
 * <img src="assets/toto.png" *appBoNavigationSidebarMenuIcon="'toto'"/>
 */
@Directive({
  selector: '[appBoNavigationSidebarMenuIcon]',
  standalone: true,
})
export class wzbBoNavigationSidebarMenuIconsDirective {
  /**
   * Icon name
   */
  name!: string;

  /**
   * Setter for icon name
   * @param {string} name matching with a {@link NavigationItem} 'icon' property
   */
  @Input('appBoNavigationSidebarMenuIcon') set iconName(name: string) {
    this.name = name;
  }

  templateRef = inject(TemplateRef<any>);
}
